import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import Loader from '@/components/Loader';
import { lazyImport } from '@/utils/lazyImport';

const { AuthRoutes } = lazyImport(async () => await import('@/modules/auth'), 'AuthRoutes');

const { GuestOrderingV2Routes } = lazyImport(
  async () => await import('@/modules/guest-order-v2'),
  'GuestOrderingV2Routes'
);

const { OpenOrderDetails } = lazyImport(
  async () => await import('@/modules/common/OpenOrderDetails'),
  'OpenOrderDetails'
);

export const publicRoutes = (config: any) => [
  {
    path: 'auth/*',
    element: (
      <Suspense fallback={<Loader />}>
        <AuthRoutes />
      </Suspense>
    ),
  },
  { path: 'guest-order-v2/*', element: <GuestOrderingV2Routes /> },
  {
    path: '/',
    element: <Navigate to={config?.otp_login ? 'auth/login-with-mobile-otp' : 'get-started'} />,
  },
  { path: '/track-order/:id', element: <OpenOrderDetails /> },
  { path: '*', element: <Navigate to="/" /> },
];
